/**
 * Expandable JavaScript singleton module
 */

var Expandable = (function($) {
  function initExpandable() {
    let $openedItem = null;

    // CLICK → abrir
    $(".news-list__item").on("click", function(e) {
      e.stopPropagation();

      const $current = $(this);
      const $info = $current.find(".news-list-info");

      if ($openedItem && $openedItem[0] === $current[0]) return;

      if ($openedItem) {
        $openedItem
          .find(".news-list-info")
          .stop(true, true)
          .slideUp();
      }

      $info.stop(true, true).slideDown();
      $openedItem = $current;
    });

    // HOVER EN OTRO ITEM → cerrar
    $(".news-list__item").on("mouseenter", function() {
      const $current = $(this);

      if ($openedItem && $openedItem[0] !== $current[0]) {
        $openedItem
          .find(".news-list-info")
          .stop(true, true)
          .slideUp();
        $openedItem = null;
      }
    });

    // LEAVE DEL ITEM ABIERTO → cerrar
    $(".news-list__item").on("mouseleave", function() {
      const $current = $(this);

      if ($openedItem && $openedItem[0] === $current[0]) {
        $openedItem
          .find(".news-list-info")
          .stop(true, true)
          .slideUp();
        $openedItem = null;
      }
    });

    // Click fuera → cerrar todo (opcional pero recomendado)
    $(document).on("click", function() {
      if ($openedItem) {
        $openedItem
          .find(".news-list-info")
          .stop(true, true)
          .slideUp();
        $openedItem = null;
      }
    });
  }

  function init() {
    if (!$(".news-list__item").length) return;
    initExpandable();
  }

  return { init: init };
})(jQuery);

jQuery(document).ready(Expandable.init);
